/**
 * React Query keys for every conversation-shaped cache. Kept dependency-free so
 * any module (hooks, stores, cache patchers, providers) can import them without
 * pulling in the hooks that own the queries.
 */

/** Paginated chat list (`useHistory`). */
export const CHAT_HISTORY_QUERY_KEY = 'chat-history'
/** Flat recent-chats list for the chat window's history preview. */
export const HISTORY_PREVIEW_QUERY_KEY = 'history-preview'
/** For You feed; scoped variants are built with `forYouFeedKey`. */
export const FOR_YOU_CHATS_QUERY_KEY = 'for-you-chats'
/** Sidepanel history activity; one entry per type filter. */
export const HISTORY_ACTIVITY_QUERY_KEY = 'sidepanel-history-activity'

/** Single conversation by id (`useHistoryByChatId`). */
export function chatQueryKey(chatId: string): readonly ['chat', string] {
  return ['chat', chatId]
}
